export default "__VITE_ASSET__951f65eb__"